module.exports = function (BreakpointsService, filtersService, moveFocus, $stateParams, $rootScope) {
    return {
        restrict: 'E',
        scope: {},
        link(scope, element) {
            let isLoading = true;

            scope.filtersService = filtersService;
            scope.searchTerm = $stateParams.searchTerm.replace(/-/g, ' ');
            scope.isSmallFormat = BreakpointsService.isSmallFormat();
            moveFocus(element);

            scope.isPageLoading = function () {
                return isLoading;
            };

            $rootScope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.isSmallFormat = BreakpointsService.isSmallFormat();
                });
            });

            isLoading = false;
        },
        template: require('./search-page-template.html')
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-page-directive.js
 **/